export default __webpack_public_path__ + "4f80944ef58a504be63bb8163befd91a.svg";